import { render, staticRenderFns } from "./menuIndex.vue?vue&type=template&id=f94022dc&scoped=true"
import script from "./menuIndex.vue?vue&type=script&lang=js"
export * from "./menuIndex.vue?vue&type=script&lang=js"
import style0 from "./menuIndex.vue?vue&type=style&index=0&id=f94022dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94022dc",
  null
  
)

export default component.exports